import { render } from "./ReconciliationNextStepPlaceholder.vue?vue&type=template&id=1ce62f09&ts=true"
import script from "./ReconciliationNextStepPlaceholder.vue?vue&type=script&lang=ts"
export * from "./ReconciliationNextStepPlaceholder.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__